import { stringify } from "query-string"

import { farasodAnalytic } from "./api"

const endpoint = "/report"

export const getReportBills = async queries => {
  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await farasodAnalytic.get(`${endpoint}/sale?${query}`)

  return response.data
}

export const getBankTransactionNotes = async queries => {
  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await farasodAnalytic.get(`${endpoint}/bankTransactionNote?${query}`)

  return response.data
}

export const getAccountsReport = async queries => {
  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await farasodAnalytic.get(`${endpoint}/account/status?${query}`)

  return response.data
}

export const getFoodStockReport = async (foodId, optionId, queries) => {
  const query =
    stringify(
      queries,
      {
        skipEmptyString: true,
        skipNull: true
      }
    )

  const response = await farasodAnalytic.get(`${endpoint}/stock/history/food/${foodId}/${optionId}?${query}`)

  return response.data
}

export const getFoodsReport = async (queries) => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasodAnalytic.get(`${endpoint}/sale/food?${query}`)

  return response.data
}

export const getFoodCategoriesReport = async (queries) => {
  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await farasodAnalytic.get(`${endpoint}/sale/food/category?${query}`)

  return response.data
}

export const getCashTypeReport = async (queries) => {
  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await farasodAnalytic.get(`${endpoint}/payment/cashtype?${query}`)

  return response.data
}

export const getSalesReport = async (queries) => {
  const query =
    stringify(queries,
      { skipEmptyString: true, skipNull: true }
    )

  const response = await farasodAnalytic.get(`${endpoint}/sale?${query}`)

  return response.data
}

export const getSaleSpecificationReport = async (queries) => {
  const query =
    stringify(queries,
      { skipEmptyString: true, skipNull: true }
    )

  const response = await farasodAnalytic.get(`${endpoint}/sale/specification?${query}`)

  return response.data
}

export const getReportBranchSale = async (queries) => {
  const query =
    stringify(queries,
      { skipEmptyString: true, skipNull: true }
    )

  const response = await farasodAnalytic.get(`${endpoint}/sale/branch?${query}`)

  return response.data
}

export const getReportCashierSale = async (queries) => {
  const query =
    stringify(queries,
      { skipEmptyString: true, skipNull: true }
    )

  const response = await farasodAnalytic.get(`${endpoint}/sale/cashiers?${query}`)

  return response.data
}

export const getReportRegisteredUsers = async (queries) => {
  const query =
    stringify(queries,
      { skipEmptyString: true, skipNull: true }
    )

  const response = await farasodAnalytic.get(`${endpoint}/registered/users?${query}`)

  return response.data
}

export const getPaidOrderStatistics = async (queries) => {
  const query =
    stringify(queries,
      { skipEmptyString: true, skipNull: true }
    )

  const response = await farasodAnalytic.get(`${endpoint}/orders/statistic?${query}`)

  return response.data
}

export const getRegisteredUsersCount = async (queries) => {
  const query =
    stringify(queries,
      { skipEmptyString: true, skipNull: true }
    )

  const response = await farasodAnalytic.get(`${endpoint}/account/count?${query}`)

  return response.data
}


export const getReportPaymentCashTypes = async (queries) => {
  const query =
    stringify(
      queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasodAnalytic.get(`${endpoint}/cash-types?${query}`)

  return response.data
}